module.exports = __webpack_public_path__ + "61f1fa38.svg";